module.exports = __webpack_public_path__ + "assets/img/destroy_mining.3a45eaf2.png";